import template from './unit-list.html';
import controller from './unit-list.controller';
import './unit-list.scss';

let unitListComponent = {
  bindings: {},
  template,
  controller
};

export default unitListComponent;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-list.component.js